// @flow
import OurStoryContainer from './OurStoryContainer';

export default OurStoryContainer;
